import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { LanguageComponent } from "./components/language/language.component";
import { LanguageGuard } from "./shared/guards/language.guard";
import { HomeComponent } from "./components/home/home.component";
import { LootboxDashboardComponent } from "./components/lootboxes/dashboard/lootbox-dashboard.component";
import { LootboxContentsComponent } from "./components/lootboxes/lootbox-contents/lootbox-contents.component";
import { NftDetailsComponent } from "./components/nft/nft-details/nft-details.component";

const routes: Routes = [
  {
    path: ":lang",
    component: LanguageComponent,
    canActivate: [LanguageGuard],
    children: [
      { path: "", component: HomeComponent },
      { path: "dashboard", component: HomeComponent },
    ],
  },
  {
    path: ":lang",
    component: LanguageComponent,
    canActivate: [LanguageGuard],
    children: [
      {
        path: "token",
        loadChildren: () =>
          import("./components/token/token.module").then((m) => m.TokenModule),
      },
    ]

  },
  {
    path: ":lang",
    component: LanguageComponent,
    canActivate: [LanguageGuard],
    children: [
      {
        path: "claim",
        loadChildren: () =>
          import("./components/claimPage/claimPage.module").then(
            (m) => m.ClaimPageModule
          ),
      },
    ]
  },
  {
    path: ":lang",
    component: LanguageComponent,
    canActivate: [LanguageGuard],
    children: [
      {
        path: "leaderboard",
        loadChildren: () =>
          import("./components/rakeback-leader-board/rakeback-leader-board.module").then(
            (m) => m.RakebackLeaderBoardModule
          ),
      },
    ]
  },
  {
    path: ":lang",
    component: LanguageComponent,
    canActivate: [LanguageGuard],
    children: [
      {
        path: "weekly-challenge",
        loadChildren: () =>
          import("./components/total-wagered-leader-board/total-wagered-leader-board.module").then(
            (m) => m.TotalWageredLeaderBoardModule
          )   
      }
    ]
  },
  {
    path: ":lang",
    component: LanguageComponent,
    canActivate: [LanguageGuard],
    children: [
      {
        path: "vip-home",
        loadChildren: () =>
          import("./components/vip/vip.module").then((m) => m.VipModule),
      },
    ]
  },
  {
    path: ":lang",
    component: LanguageComponent,
    canActivate: [LanguageGuard],
    children: [
      {
        path: "vip-landing",
        loadChildren: () =>
          import("./components/vip-landing/vip-landing.module").then(
            (m) => m.VipLandingModule
          ),
      },
    ]
  },
  {
    path: ":lang/vip",
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./components/vip-logged-in/vip-logged-in.module").then((m) => m.VipLoggedInModule),
      },
    ]
  },
  {
    path: ":lang/lootboxes",
    children: [
      {
        path: "",
        component: LootboxDashboardComponent,
      },
      {
        path: ":id",
        component: LootboxContentsComponent,
      },
    ],
  },
  {
    path: ":lang/nft",
    children: [
      {
        path: ":collectionName/:nftId",
        component: NftDetailsComponent,
      },
    ],
  },
  {
    path: ":lang",
    children: [
      {
        path: "pepe",
        loadChildren: () =>
          import("./components/pepe/pepe.module").then((m) => m.PepeModule),
      },
      {
        path: "offers",
        loadChildren: () =>
          import("./components/offers/offers.module").then(
            (m) => m.OffersModule
          ),
      },

      {
        path: "refer-and-earn",
        loadChildren: () =>
          import("./components/referral/referral.module").then(
            (m) => m.ReferralModule
          ),
      },

      {
        path: "refer-earn",
        loadChildren: () =>
          import("./components/referral/referral.module").then(
            (m) => m.ReferralModule
          ),
      },
    ],
  },
  { path: "**", redirectTo: "/dashboard", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
